import React from 'react';

import { type SmartMentionResource } from '@atlassian/smart-mention-resource';

type RovoMentionProvider = { value?: SmartMentionResource };
const initialState: RovoMentionProvider = {};

export const rovoMentionProviderDefaults: RovoMentionProvider = initialState;

const rovoMentionProvider = React.createContext<RovoMentionProvider>(initialState);
export const RovoMentionProvider: React.Provider<RovoMentionProvider> = rovoMentionProvider.Provider;
export const useRovoMentionProvider = (): RovoMentionProvider => React.useContext(rovoMentionProvider);
